// src/components/ExplorePage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const ExplorePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background text-white flex flex-col items-center justify-center px-4">
      <h1 className="text-4xl font-bold mb-6">🎓 Welcome, Student</h1>
      <p className="text-lg text-center mb-8 max-w-xl">
        Dive into timelines, challenge yourself with quizzes, and explore flashcards to master historical events.
      </p>

      <div className="grid gap-4 w-full max-w-md">
        <button
          onClick={() => navigate('/timeline')}
          className="w-full bg-card text-white px-4 py-3 rounded-xl shadow-md hover:bg-accent transition"
        >
          📜 Explore Timeline
        </button>
        <button
          onClick={() => navigate('/quiz')}
          className="w-full bg-card text-white px-4 py-3 rounded-xl shadow-md hover:bg-accent transition"
        >
          🧠 Take a Quiz
        </button>
        <button
          onClick={() => navigate('/flashcards')}
          className="w-full bg-card text-white px-4 py-3 rounded-xl shadow-md hover:bg-accent transition"
        >
          🗂️ Flashcards
        </button>
        <button
          onClick={() => navigate('/add-event')}
          className="w-full bg-card text-white px-4 py-3 rounded-xl shadow-md hover:bg-accent transition"
        >
          ➕ Add Event
        </button>
      </div>
    </div>
  );
};

export default ExplorePage;
